import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_SUPPLY_CHAIN: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteSupplyChain($input: DeleteSupplyChainInput!) {
    deleteSupplyChain(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
